export default {
    data() {
      return {};
    },
    methods: {
      redirect(o) {
        this.$router.push(o).catch(()=>{});
      },
      goDefault() {
        this.redirect({name: 'search-wizard'})
      }
    }
  }
  